import {
  createFileRoute, Outlet,
} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_authenticated/mydigitalworkers')({
  beforeLoad: () => {
    return {
      crumb: 'My Digital Workers',
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
